import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SanityImage from 'gatsby-plugin-sanity-image';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import sharedStyles from './styles';

const Title = styled.h2`
  margin: 0 0 ${sharedStyles.spacing['spacing-2xs']};
  padding: 0 ${sharedStyles.spacing['spacing-md']};
  text-transform: uppercase;
`;

const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.defaultFont};
  margin: 0;
  padding: 0 ${sharedStyles.spacing['spacing-md']}
    ${sharedStyles.spacing['spacing-md']} ${sharedStyles.spacing['spacing-md']};
  font-size: ${sharedStyles.fontSize.sm};
`;

const StyledLink = styled(LocalizedLink)`
  display: block;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.cardBackground};

  &:hover {
    background-color: ${({ theme }) => theme.colors.cardBackgroundHover};

    ${Title} {
      text-decoration: underline;
    }
  }
`;

const StyledImage = styled(SanityImage)`
  display: block;
  width: 100%;
  margin: 0 0 ${sharedStyles.spacing['spacing-md']};
  object-fit: cover;
  object-position: top;
  aspect-ratio: 1 / 1;
`;

const Description = styled.p`
  margin: 0;
  padding: 0 ${sharedStyles.spacing['spacing-md']}
    ${sharedStyles.spacing['spacing-md']} ${sharedStyles.spacing['spacing-md']};
  color: ${({ theme }) => theme.colors.cardText};
`;

function GridCard({ item }) {
  return (
    <StyledLink to={item?.link}>
      {item?.image?.asset && (
        <StyledImage
          key={`image-${item?.link || item?.title}`}
          hotspot={item.image?.hotspot}
          crop={item.image?.crop}
          asset={item.image.asset}
          alt={
            item?.image?.alt ||
            item?.SEOMetadata?.description ||
            item?.description
          }
        />
      )}

      {item?.title && <Title>{item.title}</Title>}

      {item?.subtitle && <Subtitle>{item.subtitle}</Subtitle>}

      {item?.description && <Description>{item.description}</Description>}
    </StyledLink>
  );
}

GridCard.propTypes = {
  item: PropTypes.shape({
    SEOMetadata: PropTypes.shape({
      description: PropTypes.string,
    }),
    link: PropTypes.string,
    image: PropTypes.shape({
      hotspot: PropTypes.shape({}),
      crop: PropTypes.shape({}),
      asset: PropTypes.shape({
        url: PropTypes.string,
      }),
      alt: PropTypes.string,
    }),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default GridCard;
